import { defineComponent as s, openBlock as t, createElementBlock as r, normalizeClass as l, Fragment as c, renderList as i, unref as m, createBlock as d, resolveDynamicComponent as u, toRaw as b, createCommentVNode as C } from "vue";
import { scrollToElement as f } from "../../../utils/scrollToElement.js";
import { getVNodeTextContent as y } from "../../../utils/vnode.js";
const p = ["aria-labelledby"], g = ["aria-label"], v = /* @__PURE__ */ s({
  name: "RevCardCarouselItems",
  __name: "CardCarouselItems",
  props: {
    cardClasses: { type: [String, Boolean, Array, Object] },
    items: {},
    center: { type: Boolean },
    ariaLabelledby: {}
  },
  setup(e) {
    const o = () => {
      f(document.activeElement, {
        timeout: 50,
        scroll: { behavior: "smooth", block: "nearest", inline: "center" }
      });
    };
    return (k, w) => (t(), r("ul", {
      "aria-labelledby": e.ariaLabelledby,
      class: l(["grid grid-flow-col auto-rows-max grid-rows-1 gap-8 pb-20 md:gap-16", e.center ? "w-full justify-center-safe" : "w-max"])
    }, [
      (t(!0), r(c, null, i(e.items, (a, n) => (t(), r("li", {
        key: n,
        "aria-label": m(y)(a),
        class: l(["snap-start list-none", e.cardClasses])
      }, [
        a ? (t(), d(u(b(a)), {
          key: 0,
          onFocus: o
        }, null, 32)) : C("", !0)
      ], 10, g))), 128))
    ], 10, p));
  }
});
export {
  v as default
};
